import { Box } from "../../../../components/MuiGenerals";

const LayoutRow = ({
  title,
  subtitle,
  content,
  isHide,
  titleStyle,
}: {
  title: string;
  subtitle?: React.ReactNode;
  content?: React.ReactNode;
  isHide?: boolean;
  titleStyle?: React.CSSProperties;
}) => {
  if (!content || isHide) {
    return <></>;
  }

  return (
    <div
      style={{
        display: "flex",
        marginBottom: "8px",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "center",
          minWidth: "150px",
          marginRight: "20px",
          ...titleStyle,
        }}
      >
        {title}
        {subtitle}
      </Box>
      <Box
        sx={{
          ".MuiFormControl-root": { width: "100%" },
          width: "100%",
        }}
      >
        {content || ""}
      </Box>
    </div>
  );
};

// MuiFormControl-root
export default LayoutRow;
